// client/src/config/features.ts
// Env-var-backed feature flags. Defaults false. No component consumes these yet.

function isEnabled(value: string | undefined): boolean {
  return value === "true" || value === "1";
}

// Root routing + redirect target for the homeschool pivot (Phase 3).
export const HOMESCHOOL_PRIMARY = isEnabled(process.env.REACT_APP_FEATURE_HOMESCHOOL_PRIMARY);
